import { Button, Stack, Typography } from "@mui/material";
import { Link } from "react-router";
import DialogHeader from "@entrilia/shared/components/dialog/DialogHeader";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import type { ReportInfo } from "../../../../../../api/types/svTypes.ts";
import ApiReportDialogIcon from "@entrilia/shared/icons/ApiReportDialogIcon";
import { getEditApiReportUrl } from "../utilities/editReportUrl";

interface Props {
  report: ReportInfo;
  openInNewTab?: boolean;
  onClose: () => void;
}

const OpenGeneratedApiReport = ({ onClose, report, openInNewTab }: Props) => {
  const navigateToReport = () => {
    onClose();
  };

  return (
    <>
      <DialogHeader text={"Generate API Report"} onClose={onClose} />
      <Stack spacing={1} sx={{ px: 2.5, py: 1, flex: 1, alignItems: "center", textAlign: "center" }}>
        <ApiReportDialogIcon sx={{ width: 80, height: 80 }} />
        <Typography variant="h6">The report has been generated successfully.</Typography>
        <Typography>You can now open the report in a new tab.</Typography>
      </Stack>

      <DialogButtons onCancel={onClose} cancelText="Close">
        <Button
          variant="contained"
          onClick={navigateToReport}
          component={Link}
          target={openInNewTab ? "_blank" : undefined}
          to={getEditApiReportUrl(report.clientCode, report.reportId)}
          sx={{ textTransform: "none" }}
        >
          Open the Report
        </Button>
      </DialogButtons>
    </>
  );
};

export default OpenGeneratedApiReport;
